export const RatingsMap = {
    default: 0,
    notAssessed: 0,
    red: 1,
    amber: 2,
    yellow: 3,
    green: 4,
};

export const Ratings = {
    Green: {
        value: RatingsMap.green,
        label: { text: '4 - Green' },
        text: '4 - Green',
        css: 'bg-green',
    },
    Yellow: {
        value: RatingsMap.yellow,
        label: { text: '3 - Yellow' },
        text: '3 - Yellow',
        css: 'bg-yellow',
    },
    Amber: {
        value: RatingsMap.amber,
        label: { text: '2 - Amber' },
        text: '2 - Amber',
        css: 'bg-amber',
    },
    Red: {
        value: RatingsMap.red,
        label: { text: '1 - Red' },
        text: '1 - Red',
        css: 'bg-red',
    },
    default: {
        value: RatingsMap.notAssessed,
        label: { text: 'Not Assessed' },
        text: 'Not Assessed',
        css: 'bg-requires-action',
    },
};

export const RatingsFromId = (id) => {
    if (!id) return Ratings.default;
    return Object.values(Ratings).find((x) => x.value == id);
};

// Continuous rating bands (0-4 scale), ordered ascending by upper bound. This is the single
// source of truth for chip colour classification (getRatingBand), the SARB advanced filter's
// band matching, and the "Ratings Explained" legend (sarb-advanced-filters.js) - all three used
// to define their own copy of these thresholds and drifted apart. rangeLabel is the human-
// readable range shown in the legend.
//   0 < x <= 1.0  -> Red
//   1.1 <= x <= 2.0 -> Amber
//   2.1 <= x <= 3.9 -> Yellow
//   x > 3.9 (practically x == 4, the scale max) -> Green
export const RatingBands = [
    { ...Ratings.Red, max: 1.0, rangeLabel: 'Red (0 → 1.0)' },
    { ...Ratings.Amber, max: 2.0, rangeLabel: 'Amber (1.1 → 2.0)' },
    { ...Ratings.Yellow, max: 3.9, rangeLabel: 'Yellow (2.1 → 3.9)' },
    { ...Ratings.Green, max: Infinity, rangeLabel: 'Green (4.0)' },
];

// Maps a continuous decimal rating (e.g. 3.6) to its colour band, for ratings that are no longer
// rounded to a whole number before display (SARB Overall/Consolidated/Component/Principle
// ratings). Falls back to "Not Assessed" for 0/null/undefined/NaN.
export const getRatingBand = (value) => {
    // Round to 1dp first so the band always agrees with what's displayed alongside it - banding
    // the raw value would let e.g. 2.94 (displayed as "2.9") fall into the Yellow band while its
    // rounded display reads like an Amber-boundary value.
    const v = Math.round(Number(value) * 10) / 10;
    if (!v || v <= 0) return Ratings.default;
    return RatingBands.find((band) => v <= band.max) ?? RatingBands[RatingBands.length - 1];
};
